import { useMetricMasterdataQuery } from "@/common/api/metric/use-metric-masterdata.query";
import { MetricCard } from "@/components/dashboard/cards/metric-card";
import { TruckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function VehicleMetric() {
  const { t } = useTranslation(["masterdata", "common"]);
  const { data, isLoading } = useMetricMasterdataQuery();

  return (
    <MetricCard icon={TruckIcon} label={t("common:Vehicles")} value={data?.vehicleCount ?? 0} loading={isLoading} />
  );
}
